import React from 'react'
import { Container, Label } from './styles'
import { useTheme } from 'styled-components'

export interface ItemProps {
  label: string
  Icon: any
  to: string
  active: boolean
  navigatePage?: React.MouseEventHandler<HTMLButtonElement>
  disabled: boolean
}

const Item: React.FunctionComponent<ItemProps> = ({
  Icon,
  label,
  navigatePage,
  active,
  disabled,
}) => {
  const theme: any = useTheme()
  const activeButton = disabled ? false : active
  return (
    <Container active={activeButton} onClick={navigatePage} disabled={disabled}>
      <Icon size={25} color={theme.colors.primary} />
      <Label>{label}</Label>
    </Container>
  )
}

export default Item
